<template>
	<div class="flex flex-col gap-1">
		<p v-if="updated && firstPublished !== updated" class="!mb-0">
			{{ $t("blog.updated") }} {{ formatDate(updated) }}
		</p>
		<p class="!mb-0">
			{{ $t("blog.published") }}
			{{ formatDate(firstPublished || fallbackDate) }}
		</p>
	</div>
</template>

<script setup lang="ts">
interface Props {
	updated?: string | Date;
	firstPublished?: string | Date;
	fallbackDate?: string | Date;
}

const { updated, firstPublished, fallbackDate } = defineProps<Props>();

const formatDate = (value?: string | Date) => {
	if (!value) {
		return "";
	}

	const date = new Date(value);
	const options: Intl.DateTimeFormatOptions = {
		day: "2-digit",
		month: "short",
		year: "numeric"
	};

	return new Intl.DateTimeFormat("en-GB", options).format(date);
};
</script>
